<template>
    <div class='container_wrap' v-if="isShow">
        <div class="content-box">
            <div class="title">是否确认核销该记录</div>
            <div class="userinfo" v-if="Object.keys(userinfoObj).length > 0">
                <div class="userinfo-item">{{ userinfoObj.name }}</div>
                <div class="userinfo-item time">{{ userinfoObj.day }}</div>
                <div v-if="userinfoObj.time.length > 0" >
                    <div class="userinfo-item" v-for="(item,index) in userinfoObj.time">{{showtime(item.mark_start,item.mark_end) || item.time }}</div>
                </div>
            </div>
            <div class="btn-list">
                <div class="btn-item flc" @click="close">取消</div>
                <div class="btn-item flc" @click="confirm">确认</div>
            </div>
        </div>
    </div>
</template>
<script>


export default {
    name: "toast",

    // 组件注册
    components: {},
    data() {
        return {};
    },
    props: {
        userinfoObj: {
            type: Object,
            default() {
                return {}
            }
        },
        isShow:{
            type:Boolean,
            default:false
        }
    },
    //计算属性
    computed: {
        showtime (start,end) {
            return (start,end) => {
                if (start && end ){
                    return `${start.substring(11,16)}~${end.substring(11,16)}`
                } else {
                    return ''
                }
            }
        }
    },
    // 数据监听
    watch: {},
    //方法集合
    methods: {
        confirm () {
            this.$emit('confirmWriteoff')
        },
        close () {
            this.$emit('close')
        }
    },
    //生命周期 - 创建完成
    created() {
    },
    //生命周期 - 挂载完成
    mounted() {
    },
}
</script>
<style lang='scss' scoped>
.flc {
    display: flex;
    justify-content: center;
    align-items: center;
}

.flc2 {
    display: flex;
    align-items: center;
}

.positionc {
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}

.container_wrap {
    width: 100%;
    height: 100vh;
    position: fixed;
    background: rgba(0, 0, 0, 0.6);
    left: 0;
    top: 0;

    .content-box {
        margin: 342px auto;
        width: 504px;
        min-height: 492px;
        box-sizing: border-box;
        background: #FFFFFF;
        border-radius: 16px;
        padding: 40px 28px;

        .title {
            font-size: 32px;
            font-weight: 500;
            color: #222222;
            text-align: center;
        }

        .userinfo {
            margin-top: 76px;
            .time {
                margin-top: 14px;
            }
            .userinfo-item {
                text-align: center;
                font-size: 28px;
                font-weight: 400;
                color: #318544;
            }
        }
        .btn-list {
            margin-top: 80px;
            display:grid;
            grid-template-columns: 1fr 1fr;
            height: 80px;
            column-gap: 20px;
            .btn-item {
                font-size: 28px;
                font-weight: 400;
                border-radius: 8px;

                &:nth-child(1) {
                    color: #318544;
                    border: 2px solid #318544;
                }
                &:nth-child(2) {
                    color: #FFFFFF;
                    background: #318544;
                }
            }
        }
    }
}
</style>
